import React from 'react';

export default function RequiredField() {
  return (
    <div className="RequiredField" style={{ color: 'red', display: 'inline-block' }}>
      &#42;
    </div>
  );
}
